/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface FindAllBedRooms200Response
 */
export interface FindAllBedRooms200Response {
    /**
     * 
     * @type {Array<ScreenerBedRoom>}
     * @memberof FindAllBedRooms200Response
     */
    data?: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the FindAllBedRooms200Response interface.
 */
export function instanceOfFindAllBedRooms200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllBedRooms200ResponseFromJSON(json: any): FindAllBedRooms200Response {
    return FindAllBedRooms200ResponseFromJSONTyped(json, false);
}

export function FindAllBedRooms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBedRooms200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function FindAllBedRooms200ResponseToJSON(value?: FindAllBedRooms200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

